import Vue from 'vue'
import { setCookie, getCookie, removeCookie } from '../helpers'
import axios from 'axios'

const ROLE_GENERAL = 'ROLE_GENERAL'
const ROLE_CUSTOMER_SERVICE = 'ROLE_CUSTOMER_SERVICE'
const ROLE_FREIGHT_GROUP = 'ROLE_FREIGHT_GROUP'
const ROLE_PRP_ADMIN = 'ROLE_PRP_ADMIN'
const AUTH_COOKIE_NAME = 'Returns-GAuthToken'

export default new Vue({
    data () {
        return {
            authCookieName: AUTH_COOKIE_NAME,
            token: null,
            role: null,
            // declarative helper for user roles
            userIs: {
                salesRep: () => this.role === ROLE_PRP_ADMIN || this.role === ROLE_GENERAL,
                customerService: () => this.role === ROLE_PRP_ADMIN || this.role === ROLE_CUSTOMER_SERVICE,
                freightGroup: () => this.role === ROLE_PRP_ADMIN || this.role === ROLE_FREIGHT_GROUP,
                prpAdmin: () => this.role === ROLE_PRP_ADMIN,
                corpUser: () => this.role === ROLE_PRP_ADMIN || this.role === ROLE_CUSTOMER_SERVICE || this.role === ROLE_FREIGHT_GROUP
            }
        }
    },
    methods: {
        init () {
            // if mode if dev, set helper functions on window
            if (process.env.NODE_ENV === 'development') {
                window.getCookie = getCookie
                window.setCookie = setCookie
                window.removeCookie = removeCookie
                window.getAuthCookie = () => getCookie(AUTH_COOKIE_NAME)
                window.setAuthCookie = (token) => setCookie(AUTH_COOKIE_NAME, token)
                window.removeAuthCookie = () => removeCookie(AUTH_COOKIE_NAME)
                window.getRole = () => this.role
                window.setRole = {
                    salesRep: () => (this.role = ROLE_GENERAL),
                    customerService: () => (this.role = ROLE_CUSTOMER_SERVICE),
                    freightGroup: () => (this.role = ROLE_FREIGHT_GROUP),
                    prpAdmin: () => (this.role = ROLE_PRP_ADMIN)
                }
                window.setAuth = {
                    salesRep: () => setCookie(AUTH_COOKIE_NAME, process.env.VUE_APP_SALES_REP_TOKEN),
                    customerService: () => setCookie(AUTH_COOKIE_NAME, process.env.VUE_APP_CUSTOMER_SERVICE_TOKEN),
                    freightGroup: () => setCookie(AUTH_COOKIE_NAME, process.env.VUE_APP_FREIGHT_GROUP_TOKEN),
                    prpAdmin: () => setCookie(AUTH_COOKIE_NAME, process.env.VUE_APP_PRP_ADMIN_TOKEN)
                }
            }

            this.token = getCookie(AUTH_COOKIE_NAME) || null
        },
        validateUser () {
            const formData = new FormData()
            formData.set('token', this.token)

            return axios.post('/api/users/checkToken', formData)
                .then(res => {
                    const data = res.data.data
                    if (data.valid) {
                        // set user role
                        this.role = data.role
                        return res
                    } else {
                        const error = new Error('Invalid Token')
                        error.status = 401
                        throw error
                    }
                })
        },
        /**
         * determines what is the user role
         * @param {Array} roles array of roles
         */
        determineRole (roles) {
            const found = roles.find(item => (
                item.role === ROLE_GENERAL
                || item.role === ROLE_CUSTOMER_SERVICE
                || item.role === ROLE_FREIGHT_GROUP
                || item.role === ROLE_PRP_ADMIN
            ))
            return found ? found.role : null
        }
    }
})
